import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_002",
  "use": "icon-su_002-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-su_002\"><defs><style>#icon-su_002 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-su_002_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_002_icon\"><rect class=\"cls-1\" width=\"24\" height=\"24\" /><path class=\"cls-2\" d=\"M19,3H18V8H6V3H3V21H21V5Zm0,16H5V13H19Z\" /><rect class=\"cls-2\" x=\"8\" y=\"3\" width=\"8\" height=\"3\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol